import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  scroll() {
    let target = document.querySelector(this.element.dataset.scrollAfter);
    window.scrollTo({
      top:
        window.scrollY +
        target.getBoundingClientRect().top +
        target.offsetHeight,
      behavior: "smooth",
    });
  }
}
